import Vue, { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'

import { Annotate } from './../../decorators/annotate'

import './stopwatch.sass'

@Component
@Annotate('Displays a stylized stopwatch with one numeric and two circular, overlapping progress indicators.')
export class Stopwatch extends Vue {

  @Prop({ required: true })
  @Annotate('The radius of the circular progress indicators, in pixels')
  radius: number

  @Prop({ required: true })
  @Annotate('The thickness of the circular progress indicators, in pixels')
  stroke: number

  @Prop({ required: true })
  @Annotate('The value of the numeric progress indicator; must be a non-negative integer.')
  counter: number

  @Prop({ required: true })
  @Annotate('The value of the first circular progress indicator; must be an integer between 0 and 100.')
  progress: number

  @Prop({ required: true })
  @Annotate('The value of the second circular progress indicator; must be an integer between 0 and 100.')
  projection: number

  private outerRadius: number
  private innerRadius: number

  private circumference: number

  created () {
    this.outerRadius = 2 * this.radius
    this.innerRadius = this.radius - (this.stroke * 0.5)

    this.circumference = 2 * Math.PI * this.innerRadius
  }

  render (h: CreateElement) {
    let progressOffset = this.circumference * (1.0 - (this.progress * 0.01))
    let projectionOffset = this.circumference * (1.0 - (this.projection * 0.01))

    return (
      <div class='stopwatch' style={{ width: this.outerRadius + 'px', height: this.outerRadius + 'px' }}>
        <svg xmlns='http://www.w3.org/2000/svg' width={this.outerRadius} height={this.outerRadius}>
          <circle r={this.innerRadius} cy={this.radius} cx={this.radius} stroke-width={this.stroke} stroke='#E4E4E4' fill='white' />
          <circle r={this.innerRadius} cy={this.radius} cx={this.radius} stroke-width={this.stroke} stroke='#AACAFB' fill='transparent' stroke-dasharray={this.circumference} stroke-dashoffset={projectionOffset} />
          <circle r={this.innerRadius} cy={this.radius} cx={this.radius} stroke-width={this.stroke} stroke='#007FFF' fill='transparent' stroke-dasharray={this.circumference} stroke-dashoffset={progressOffset} />
        </svg>

        <div class='center-both'>
          <div style={{ 'font-size': (0.8 * this.radius) + 'px' }}>{this.counter}</div>
        </div>
      </div>
    )
  }

}
